import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeBrachOffices = gql`
  type BranchOfficeAddress {
    street: String
    city: String
    name: String
    nameAddition: String
    zipCode: String
    country: String
    poBox: String
  }

  type LogisticsChain {
    id: ID!
  }

  type BranchOffice {
    id: String
    title: String
    companyId: String
    
    numberOfEmployees: Float
    phone: String
    fax: String

    billingAddress: BranchOfficeAddress
    deliveryAddress: BranchOfficeAddress

    status: String
    shop: Boolean

    emailPayment: String
    emailGeneral: String

    openingHoursSummerMondayToThursday: String
    openingHoursSummerFriday: String
    openingHoursSummerSaturday: String
    openingHoursSummerPeriodStart: String
    openingHoursSummerPeriodEnd: String
    openingHoursWinterMondayToThursday: String
    openingHoursWinterFriday: String
    openingHoursWinterSaturday: String
    openingHoursWinterPeriodStart: String
    openingHoursWinterPeriodEnd: String

    logisticsChain: [LogisticsChain]
  }

  type BranchOffices {
    limit: Int
    offset: Int
    count: Int
    total: Int

    items: [BranchOffice]
  }

  type Query {
    branchOffice(id: ID!, lang: String = "", cdn: Boolean = true): BranchOffice

    branchOffices(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      sortWithinLimits: Boolean = false
      lang: String = ""
      cdn: Boolean = true
    ): BranchOffices
  }
`

export { typeBrachOffices }

export default typeBrachOffices
